module.exports = __webpack_public_path__ + "img/placeholder-card.3c8a5aa6.svg";